import React from "react";
import PropTypes from "prop-types";
import { Button } from "rsuite";
import BookOpenIcon from "../../../../assets/img/action-center/book-open.svg";
import ChevronRightSmIcon from "../../../../assets/img/action-center/chevron-right-sm.svg";
import useHeapCardViewed from "../../../../hooks/useHeapCardViewed";
import "./KnowledgeBaseCard.scss";

const KB_URL = "https://hoteltrader.knowledgeowl.com/help";

const KnowledgeBaseCard = ({ cardPosition, hotelName }) => {
  const cardRef = useHeapCardViewed("knowledge_base", cardPosition, hotelName);
  const handleExplore = () => {
    window.open(KB_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <div ref={cardRef} className="kb-card">
      <div className="kb-card-badge">
        <img src={BookOpenIcon} alt="" className="badge-icon" />
      </div>

      <h3 className="kb-card-title">Explore our Knowledge Base</h3>

      <p className="kb-card-description">
        Discover tips, tutorials, and best practices to maximise your
        property&apos;s performance.
      </p>

      <div className="kb-card-actions">
        <Button
          id="action-kb-explore"
          appearance="ghost"
          className="explore-btn"
          onClick={handleExplore}
        >
          Browse Articles{" "}
          <img src={ChevronRightSmIcon} alt="" className="btn-chevron" />
        </Button>
      </div>
    </div>
  );
};

KnowledgeBaseCard.propTypes = {
  cardPosition: PropTypes.number,
  hotelName: PropTypes.string,
};

export default KnowledgeBaseCard;
